import { Component, OnInit, Input, EventEmitter, Output, ComponentFactoryResolver, ViewContainerRef, ViewChild } from '@angular/core';
import { LangService } from 'src/app/core/services/lang.service';
import { ModalService } from 'src/app/shared/services/modal.service';
import { fixedValues } from 'src/app/shared/constants/fixed-values.enum';
import { OtherBill } from '../../../models/other-bill.model';
import { CommonService } from '../../../services/common.service';
import { DataService } from '../../../services/forms/configuration/data.service';
import { AlertService } from 'src/app/shared/popup/service/alert.service';

@Component({
  selector: 'app-other-bill-accounts',
  templateUrl: './../../../templates/forms/modals/other-bill-accounts.component.html',
})
export class OtherBillExpenceAccountsComponent implements OnInit {
  @ViewChild('modalContainer', { static: true, read: ViewContainerRef }) container;

  @Input()
  config: any;

  @Input()
  modalShow: boolean = true;

  @Output()
  submit: EventEmitter<any> = new EventEmitter<any>();

  dataObj:any;

  @Input()
  otherBillList:OtherBill[];

  billTypeList = []

  private modal:ModalService;
  public searchString;
  public selectedLookupDtlNo = 0;
  public selectedEmplpoyee;

  constructor(
    public langService: LangService
    , private commonService: CommonService
    , private alertService: AlertService
    , private dataService: DataService) {
  }

  onClickAddNewConveyance() {
    let obj = {
      BILLTYPEDTL_NO: Number(this.selectedLookupDtlNo)
    }
    this.otherBillList.push(new OtherBill(obj));
  }

  onClickOpenEmployeeListModal(_otherBill, index) {
    this.modal.createEmployeeListComponent(this.container, _otherBill, this);
    this.selectedEmplpoyee = index;
  }
  onClickOpenAccountsListModal(_otherBill) {
    this.modal.createAccountsListComponent(this.container, _otherBill);
  }
  onClickRemoveAccountsListModal(index, otherBill) {
    if(otherBill.SQL_STATE == 1) {
        this.otherBillList.splice(index, 1);
    }
    else {
        otherBill.SQL_STATE = fixedValues.sqlState.sqlDelete;
    }
  }
  ngOnInit() {
    this.commonService.getDistricts(fixedValues.queryOptions.LookupNo)
      .subscribe(arg => { this.billTypeList = arg.body });
  }
  checkPreviousEmployee(EMP_NO) {
    let sameBudgetList = this.otherBillList.filter(function (el) {
      return el.EMP_NO == EMP_NO;
    });
    if (sameBudgetList.length >= 2) {
      this.alertService.warning("This Employee already exist, please select another employee!");
      this.otherBillList[this.selectedEmplpoyee].EMP_NO = null;
      this.otherBillList[this.selectedEmplpoyee].EMP_NAME = '';
    }
  }
  onClickSaveConveyance(){
    this.dataService.saveBillEmp(this.otherBillList).subscribe(result => {
    })
  }
  onChangeBillType(){
    this.dataService.getBMBillEmpExpAccounts(this.selectedLookupDtlNo).subscribe(result => {
      this.otherBillList = result.body;
    });
  }

}
